import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/features/auth/authStore';
import { listNotifications, markAllRead } from '@/api/notifications';

const useToken = () => useAuthStore((s) => s.accessToken);

export function useNotifications() {
  const token = useToken();
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => listNotifications(token as string),
    enabled: !!token,
  });
}

export function useMarkAllRead() {
  const token = useToken();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => markAllRead(token as string),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
